import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../../Store';

export default function AdminRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return userInfo && userInfo.isAdmin ? children : <Navigate to="/signin" />;
} // this function is a wrapper for other Route components (in the App.js file). Before routing to a screen that is wrapped by this function, it checks if the user is an admin and only than allows the user to access this route
